<div>
  <header *ngIf="sidebarClosed">
    <button class="toggle-sidebar closed" (click)="toggleSidebar()">
      <i class="fas fa-bars"></i>
    </button>
  </header>

  <div class="sidebar" [class.hidden]="sidebarClosed" appSwipe (swipeleft)="toggleSidebar()">
    <div class="header">
      <img class="logo" src="assets/images/sparkly_logo.png" alt="Logo" (click)="navigateToDashboard()">
      <button class="toggle-sidebar" (click)="toggleSidebar()">
        <i-tabler name="layout-sidebar-left-collapse" class="close-sidebar-icon"></i-tabler>
      </button>
    </div>

    <!--<div class="create-folder">
      <i-tabler class="folders-icon" name="plus"></i-tabler>
      <span>Datei hochladen</span>
    </div>-->

    <ul class="menu">
      <div class="main">
        <a (click)="closeIfTablet()" [routerLink]="'home'" routerLinkActive="active">
          <li class="menu-item">
            <i-tabler name="layout-dashboard"></i-tabler>
            Dashboard
          </li>
        </a>
        <a (click)="closeIfTablet()" [routerLink]="'smart-repetition'" routerLinkActive="active">
          <li class="menu-item smart-repetition">
            <i-tabler name="repeat"></i-tabler>
            <span class="title">Smartes Wiederholen</span>
            <span *ngIf="repeatCardsCount" class="flashcards-count"><tabler-icon name="repeat"></tabler-icon>{{repeatCardsCount}}</span>
          </li>
        </a>
        <ng-container>
          <a (click)="closeIfTablet()" [routerLink]="'courses'" routerLinkActive="active">
            <li class="menu-item courses">
              <i-tabler name="folders"></i-tabler>
              Deine Ordner
              <i-tabler class="expand-icon" [name]="coursesExpanded ? 'chevron-up' : 'chevron-down'" (click)="$event.preventDefault(); $event.stopPropagation(); coursesExpanded = !coursesExpanded"></i-tabler>
            </li>
          </a>
          
          <div *ngIf="coursesExpanded" class="folders-container">
              <ng-container *ngFor="let course of courses">
                <a [routerLink]="'courses/' + course.id" routerLinkActive="active" (click)="closeIfTablet()">
                  <li class="menu-item subfolder">
                    <i-tabler class="folders-icon" name="folder" [style.stroke]="course.color"></i-tabler>
                    <span>{{course.name}}</span>
                    <!--<i-tabler *ngIf="course.learnsets && course.learnsets.length > 0" class="expand-icon" [name]="course.isExpanded ? 'chevron-up' : 'chevron-down'" (click)="$event.preventDefault(); $event.stopPropagation(); course.isExpanded = !course.isExpanded"></i-tabler>-->
                  </li>
                </a>
              </ng-container>
            </div>
        </ng-container>
        <!--<div class="create-folder" (click)="showCreateFolderDialog = true">
          <i-tabler class="folders-icon" name="plus"></i-tabler>
          <span>Neues Lernkartenset</span>
        </div>-->
        
      </div>

      <!--<div class="divider"></div>

      <span class="folder-heading">Deine Ordner</span>

      <div class="create-folder" (click)="showCreateFolderDialog = true">
        <i-tabler class="folders-icon" name="plus"></i-tabler>
        <span>Neuer Ordner</span>
      </div>-->

      <!--<div *ngIf="courses" class="folders-container">
        <ng-container *ngFor="let course of courses">
          <a [routerLink]="'courses/' + course.id" routerLinkActive="active" (click)="closeIfTablet()">
            <li class="menu-item folder">
              <i-tabler class="folders-icon" name="folder" [style.stroke]="course.color"></i-tabler>
              <span>{{course.name}}</span>
              <i-tabler *ngIf="course.learnsets && course.learnsets.length > 0" class="expand-icon" [name]="course.isExpanded ? 'chevron-up' : 'chevron-down'" (click)="$event.preventDefault(); $event.stopPropagation(); course.isExpanded = !course.isExpanded"></i-tabler>
            </li>
          </a>
          <ng-container *ngIf="course.isExpanded">
            <a *ngFor="let learnset of course.learnsets" [routerLink]="'resources/' + learnset.id" routerLinkActive="active" (click)="closeIfTablet()">
              <li class="menu-item subfolder">
                <i-tabler class="folders-icon" name="file-type-pdf"></i-tabler>
                <span>{{learnset.name}}</span>
              </li>
            </a>
          </ng-container>
        </ng-container>
      </div>-->
    </ul>

    <div class="footer">
      <!--<div *ngIf="trialEndText" class="trial-info">
        <p class="trial-text">{{trialEndText}}</p>
        <app-button [text]="'Abo abschließen'" [style]="'outlined'" [size]="'small'" (clickEvent)="getPremium()"></app-button>
      </div>-->

      <a (click)="closeIfTablet()" [routerLink]="'settings'" routerLinkActive="active">
        <li class="menu-item">
          <i-tabler name="settings"></i-tabler>
          Einstellungen
        </li>
      </a>
      <a class="logout" (click)="logOut()"><li class="menu-item">
        <i-tabler name="logout"></i-tabler>
        Ausloggen
      </li></a>

      <div *ngIf="user && !user.isPremiumUser" class="premium-widget">
        <h2><i-tabler name="diamond"></i-tabler>Premium-Upgrade</h2>
        <div class="benefit">
          <p>Alles was du brauchst um maximal effizient zu lernen</p>
        </div>
        <app-button [text]="'Vorteile entdecken'" [size]="'small'" [style]="'outlined'" (clickEvent)="getPremium()"></app-button>
      </div>
    </div>
  </div>
</div>

<!--<app-bottom-dialog [isVisible]="showCreateFolderDialog" [title]="'Ordner erstellen'" (actionCancelled)="showCreateFolderDialog = false">
  <app-create-folder *ngIf="showCreateFolderDialog" (folderCreationFinished)="showCreateFolderDialog = false; getFolders()"></app-create-folder>
</app-bottom-dialog>-->